export const AllImages = [
  {
    imgLink: "https://img3.hkrtcdn.com/22873/bnr_2287202_o.jpg",
  },
  {
    imgLink: "https://img1.hkrtcdn.com/22873/bnr_2287230_o.png",
  },
  {
    imgLink: "https://img1.hkrtcdn.com/22873/bnr_2287220_o.jpg",
  },
  {
    imgLink: "https://img9.hkrtcdn.com/22873/bnr_2287228_o.png",
  },
  {
    imgLink: "https://img1.hkrtcdn.com/22873/bnr_2287240_o.jpg",
  },
];

export const midBanner = [
  {
    imgLink: "https://img1.hkrtcdn.com/22559/bnr_2255890_o.jpg",
  },
  {
    imgLink: "https://img5.hkrtcdn.com/22743/bnr_2274254_o.jpg",
  },
  {
    imgLink: "https://img9.hkrtcdn.com/22743/bnr_2274258_o.jpg",
  },
];

export const lastBanner = [
  {
    imgLink: "https://img3.hkrtcdn.com/22874/bnr_2287312_o.jpg",
  },
  {
    imgLink: "https://img5.hkrtcdn.com/22814/bnr_2281334_o.png",
  },
  {
    imgLink: "https://img5.hkrtcdn.com/22781/bnr_2278004_o.png",
  },
  {
    imgLink: "https://img3.hkrtcdn.com/22781/bnr_2278002_o.jpg",
  },
];
